import React from 'react'
import styled from '@emotion/styled'
import ImageCard from 'src/components/atoms/ImageCard'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { BreakPoint } from 'src/components/shared/CssValues'

const SPSlider = ({ cardData }) => {
  return (
    <Wrapper>
      <Slider dots slidesToShow={1.03}>
        {cardData.map((data, i) => (
          <ImageCard
            ImageTop={data.ImageTop}
            ImageLogo={data.ImageLogo}
            title={data.title}
            text={data.text}
            linkTo={data.linkTo}
            key={i}
          />
        ))}
      </Slider>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: none;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    display: inherit;
  }
`

export default SPSlider
